import { render, staticRenderFns } from "./setting-service.vue?vue&type=template&id=5b78995e&"
import script from "./setting-service.vue?vue&type=script&lang=js&"
export * from "./setting-service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports